module.exports = __webpack_public_path__ + "static/media/logoLogin.bfae5c1d.svg";